import { read } from './vault.http'
import { id, object, digest } from '@/services/legalControl/workflow'
import type { EvidencePage } from './subjectVerifications'

/** Current authorized immutable versions;an intake declaration grants no read. */
export async function businessEvidence(
  client: string,
  page: number,
  pageSize: number
): Promise<EvidencePage> {
  const selected = id(client)
  if (
    !Number.isSafeInteger(page) ||
    page < 1 ||
    page > 100000 ||
    !Number.isSafeInteger(pageSize) ||
    pageSize < 1 ||
    pageSize > 100
  )
    throw new Error('Choose a bounded evidence page')
  const value = object(
    await read<unknown>(`/client-vault/${selected}/versions`, { page, page_size: pageSize })
  )
  if (
    Object.keys(value).sort().join(',') !== 'items,page,page_size,total' ||
    !Array.isArray(value.items) ||
    typeof value.total !== 'number' ||
    !Number.isSafeInteger(value.total) ||
    value.total < 0 ||
    value.page !== page ||
    value.page_size !== pageSize ||
    value.items.length !== Math.min(pageSize, Math.max(0, value.total - (page - 1) * pageSize))
  )
    throw new Error('Authorized Vault evidence page unavailable')
  const seen = new Set<string>()
  const items = value.items.map(v => {
    const r = object(v),
      version = id(r.version_id)
    if (
      r.client_id !== selected ||
      version !== r.version_id ||
      seen.has(version) ||
      typeof r.filename !== 'string' ||
      !r.filename.length ||
      r.filename.length > 255 ||
      /[\x00-\x1f\x7f/\\]/.test(r.filename) ||
      !Number.isSafeInteger(r.version_number) ||
      Number(r.version_number) < 1 ||
      Number(r.version_number) > 2147483647 ||
      typeof r.content_sha256 !== 'string' ||
      !digest.test(r.content_sha256) ||
      r.state !== 'available' ||
      (r.classification !== 'client_controlled' && r.classification !== 'client_output') ||
      (r.basis !== 'controller' && r.basis !== 'grant' && r.basis !== 'retention') ||
      r.read_only !== (r.basis === 'retention')
    )
      throw new Error('Exact authorized Vault evidence version required')
    id(r.resource_id)
    seen.add(version)
    return {
      id: version,
      name: r.filename,
      version: Number(r.version_number),
      digest: r.content_sha256,
      available: true,
    }
  })
  return { items, total: value.total, page, page_size: pageSize }
}
